import {
  aiConnectionProbeSchema,
  aiConnectionSchema,
  type AiConnectionProbe,
  type UpdateAiConnectionRequest,
} from '@gb-ticket/shared-types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api';

/** Matches `DataInvalidationScope.AI` so a save refreshes this screen without a reload. */
export const aiConnectionQueryKey = ['ai', 'connection'] as const;

export function useAiConnection() {
  return useQuery({
    queryKey: aiConnectionQueryKey,
    queryFn: () => apiFetch('/ai/connection', aiConnectionSchema),
    refetchOnWindowFocus: true,
  });
}

export function useUpdateAiConnection() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateAiConnectionRequest) =>
      apiFetch('/ai/connection', aiConnectionSchema, {
        method: 'PATCH',
        body: JSON.stringify(body),
      }),
    onSuccess: (data) => {
      queryClient.setQueryData(aiConnectionQueryKey, data);
    },
  });
}

export function useProbeAiConnection() {
  return useMutation({
    mutationFn: (): Promise<AiConnectionProbe> =>
      apiFetch('/ai/connection/probe', aiConnectionProbeSchema, { method: 'POST' }),
  });
}
